import { OrderBusinessFeatures } from '../entity/business-features.entity';

export const USMarket: OrderBusinessFeatures = {
  showSummaryTotalAddonDescription: true,
  getOrderSummaryTotalAddonDescription: (inCartPage?: boolean) => {
    // return inCartPage ? 'Excl. Tax' : '';
    return 'Excl. Tax';
  },
  showSalesTax: true,
  zipcodeFormatUtil: (value: string) => value,
  defaultCity: {
    city: 'Los Angeles',
    state: 'CA',
    zipcode: '90024',
  },
};
